import { RoundButton } from '@/components/buttons/Buttons';
import { Dialog, type DialogProps } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import style from '../../../views/employee.module.css';

type RideFare = {
	base: number;
	distance: string;
	fee: number;
	time: number;
	surgeCharges: number;
	promo?: number;
	total: number;
};

interface Props extends DialogProps {
	rideFare: RideFare;
}

const RideFareBreakDownModal = (props: Props) => {
	const { onHide, rideFare, ...rest } = props;
	const headerTemplate = (
		<h1 className="text-headline-large text-neutral17">
			Ride Fare Breakdown
		</h1>
	);

	const footerTemplate = (
		<RoundButton label="Close" id="close" onClick={onHide} className="text-white" />
	);

	const listTemplate = (label: string, value: string) => (
		<div className="flex justify-between text-body-medium">
			<span className="text-neutral50 py-2 px-3">{label}</span>
			<span className="text-neutral4 py-2 px-3">{value}</span>
		</div>
	);

	return (
		<Dialog
			{...rest}
			onHide={onHide}
			closable={false}
			footer={footerTemplate}
			header={headerTemplate}
			pt={{
				root: () => ({
					className: classNames(
						style.employeeModalTop,
						style.employeeModalBottom,
						'w-[516px]',
					),
				}),
				header: {
					className: classNames(
						style.employeeModalHeader,
						style.employeeModalTop,
					),
				},
				content: {
					className: classNames(style.employeeModalContent),
				},
				footer: {
					className: classNames(style.employeeModalBottom),
				},
			}}
		>
			<div>
				{listTemplate('Base Fare', `₱${rideFare.base.toFixed(2)}`)}
				{listTemplate(
					`Distance (${rideFare.distance})`,
					`₱${rideFare.fee.toFixed(2)}`,
				)}
				{listTemplate('Time', `₱${rideFare.time.toFixed(2)}`)}
				{listTemplate(
					'Surge Charges',
					`₱${rideFare.surgeCharges.toFixed(2)}`,
				)}
			<Divider
				pt={{
					root: {
						className: style.employeeDivider,
					},
				}}
			/>
		{rideFare.promo ? (
			<>
				{listTemplate('Promo', `₱${rideFare.promo.toFixed(2)}`)}
			</>
		) : null}
				<hr className="border-neutral80 mx-1" />
				<div className="flex justify-between text-body-medium">
					<span className="text-neutral4 py-2 px-3">Total Paid</span>
					<span className="text-neutral10 font-bold py-2 px-3">
						₱{rideFare.total.toFixed(2)}
					</span>
				</div>
			</div>
		</Dialog>
	);
};

export default RideFareBreakDownModal;
